<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <Select
            label="Type"
            name="type_id"
            v-model="form.type_id"
            class="mt-2 col-span-3"
            :options="[
                { value: 1, name: 'Blog' },
                { value: 2, name: 'Guide' },
            ]"
            :error="errors.type_id ? errors.type_id[0] : null"
        />

        <input-text
            name="name"
            label="* Name"
            class="mt-2"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "TagForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                type_id: this.getFormData("type_id"),
                name: this.getFormData("name"),
            },
        };
    },
};
</script>
